import {getCookie} from "@js/globalFunctions/cookieHandling";

$(document).ready(function() {

	$(document).on('click', '.language-selector a:not(.smallsprite)', function () {
		const sorting = getCookie('searchOrder');
		let str = '';
		if (searchParameters.hasParameters() === false && undefined === sorting) { return; }

		const trueExceptions = ['152'];

		if(searchParameters.hasParameters())
		{
			$.each(searchParameters.getParameters(), function (k, v) {
				if (v === 'True' && trueExceptions.indexOf(k) === -1) { v = 1; }
				str += '&' + k + '=' + v;
			});
		}

		if(typeof sorting !== 'undefined' && sorting !== 'default')
			str += '&searchOrder='+sorting

		let preFilter = "";
		let afterFilter = "";

		if (window.location.href.indexOf("?result") > -1) {
			preFilter += "?result&";
			afterFilter += "/#/page=/1";
		}
		else {
			preFilter += "#";
			afterFilter += "";
		}

		if (str !== "") {
			$(this).attr('href', this.href + preFilter + 'filter=1' + str + afterFilter);
		}
		else {
			$(this).attr('href', this.href);
		}

	});
});
